import clsx from 'clsx';
import _ from 'lodash';
import React from 'react';

import Avatar from '@/src/components/common/Avatar/Avatar';
import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';

class List extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { id, className } = this.props;
    const avatars = this.props.avatars?.filter((a) => a);

    return (
      <React.Fragment>
        {(avatars || []).slice(0, 3).map((m, i) => (
          <Avatar
            key={`avatarList_${id}-${i}`}
            id={`avatar_${this.props.idKey
                ? m[this.props.idKey.split('.')[0]][this.props.idKey.split('.')[1]]
                : m.id
              }${id ? '_' + id : ''}_${i}`}
            className={className}
            name={this.props.renderer(m)}
          />
        ))}
        {(avatars || []).length > 3 && (
          <div className={clsx('avatarElement', className)} key={`avatarListItem_${id}`}>
            <div className="avatarContainer" data-tooltip-id={`avatarExcess_${id}_tooltip`}>
              <div className="avatarItem">+{(avatars || []).length - 3}</div>
            </div>
            <Tooltip id={`avatarExcess_${id}_tooltip`} place="bottom" effect="solid">
              {(avatars || [])
                .filter((m) => m)
                .slice(3, (avatars || []).length)
                .map((m, i) => (
                  <p
                    key={`otherWorkstreamMembers_${this.props.idKey
                        ? m[this.props.idKey.split('.')[0]][this.props.idKey.split('.')[1]]
                        : m.id
                      }${id ? '_' + id : ''}_${i}`}
                  >
                    {this.props.renderer(m)}
                  </p>
                ))}
            </Tooltip>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default List;
